module.exports = __webpack_public_path__ + "img/mobile.e5c4ba08.svg";